var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card spezialcard has-background-black-ter"},[_c('div',{staticClass:"card-content"},[_c('live-line-chart',{attrs:{"chart-data":_vm.liveData,"options":_vm.myOptions}}),_c('br')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }